var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCubesHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.383,
    height: 81.044,
    viewBox: "0 0 92.383 81.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.893 -35.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.882,160.9,0,147.113V174.69l23.882,13.788Z",
    transform: "translate(0 -88.343)",
    fill: "#79c6e4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.893 55.705)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.882,160.9,0,147.113V174.69l23.882,13.788Z",
    transform: "translate(0 -147.113)",
    fill: "#53ffe9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.355,160.9l23.882-13.788V174.69l-23.882,13.788Z",
    transform: "translate(-114.473 -88.343)",
    fill: "#79c6e4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.989 55.705)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.355,160.9l23.882-13.788V174.69l-23.882,13.788Z",
    transform: "translate(-138.355 -147.113)",
    fill: "#53ffe9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.764,81.022,23.882,94.811,0,81.022,23.882,67.234Z",
    transform: "translate(-0.893 -25.317)",
    fill: "#53ffe9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.615,0A23.615,23.615,0,1,1,0,23.615,23.615,23.615,0,0,1,23.615,0Z",
    transform: "translate(44.259 35.154)",
    fill: "#ffd10a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.054,79.519a23.617,23.617,0,0,1-37.545,27.658,23.617,23.617,0,1,0,37.545-27.658Z",
    transform: "translate(-206.638 -37.602)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.721,188.433l-22.1-48.09a2.371,2.371,0,0,0-4.309,0l-22.1,48.09c0,4.395,10.858,7.958,24.251,7.958S231.721,192.828,231.721,188.433Z",
    transform: "translate(-147.396 -80.192)",
    fill: "#c3bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.638,140.359a2.346,2.346,0,0,0-2.411-1.364,2.42,2.42,0,0,1,.933,1.393L336.9,194.847c5.963-1.45,9.83-3.776,9.83-6.4Z",
    transform: "translate(-262.409 -80.208)",
    opacity: 0.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubesHover);
export default __webpack_public_path__ + "static/media/cubes-hover.291f936f28ea9c8ad45996f14dadc992.svg";
export { ForwardRef as ReactComponent };